const labels = {
    LBL_LOGIN_TITLE: 'GDPR Portal connection',
    LBL_USERNAME: 'Username',
    LBL_PASSWORD: 'Password',
    LBL_RESET_PASSWORD_TITLE: 'Forgotten password ?',
    LBL_RESET_PASSWORD_TEXT: 'Fill in the form below and we will send you by email the necessary information to access your account.',
    LBL_EMAIL_ADDRESS: 'Email address',
    LBL_GOTO_LOGIN_PAGE: 'Go to the login page',
    LBL_EXPORT: 'Export data',
    LBL_FORGET_ME: 'Delete data',
    LBL_SAVE: 'Save',
    LBL_CONSENTS_MANAGER: 'Consents management',
    LBL_PERSONNEL_CONSENTS_DATA: 'Personal data and consents',
    LBL_FORGET_ME_CONFIRM: 'Yes, delete my data',
    LBL_CANCEL: 'Cancel',
    LBL_REQUEST_ACCESS_TITLE: "Request access",

    LBL_LOGIN_ERROR: 'Username or password invalid',

    LBL_RESET_PASSWORD_DONE: 'The connection parameters are sent to your email',
    LBL_SAVE_DONE: 'The changes have been made',
    LBL_EXPORT_DONE: "Data export is in progress, you will receive the download link by email",
    LBL_REQUEST_ACCESS_DONE: 'Your request has been taken into account',
    LBL_ARE_YOU_SURE: 'Are you sure ?',
    LBL_FORGET_ME_TEXT: 'All your data will be deleted ! !',
    LBL_DOWNLOAD_IN_PROGRESS: 'Downloading...',
    LBL_PORTAL_ACCESS_REFUSED: 'Access to the portal refused !',
    LBL_EMAIL_IS_NOT_REGISTERED: 'Email is not registered !',
    LBL_SYSTEM_ERROR: 'Operation not permitted',
    LBL_CREDENTIALS_ALREADY_EXIST: 'Email already registered',

    LBL_GDPR_PORTAL: 'GDPR Portal',
    LBL_LOGIN_PAGE: 'Login',
    LBL_PASSWORD_RECOVERY_PAGE: 'Reset password',
    LBL_HOME_PAGE: "Home page",
    LBL_DOWNLOAD_PAGE: 'Download data',
    LBL_REQUEST_ACCESS_PAGE: "Request access to portal",
}

export default labels


// WEBPACK FOOTER //
// ./src/languages/en_us.js